/**
 * Auto-named sessions read "Jai's Hyrox Session - Jul 21, 6:00 PM"; the card
 * already shows the date tile and time row, so the stamped suffix is noise.
 */
export function displaySessionTitle(title: string) {
  return (
    title
      .replace(
        /\s+[-–·]\s+[A-Z][a-z]{2,8}\s+\d{1,2},?\s+\d{1,2}:\d{2}\s*[AaPp][Mm]\s*$/,
        "",
      )
      .trim() || title
  );
}
